<template>
  <divs>
    <GmapMap
      ref="gmap"
      :center="center"
      :zoom="initializedZoom"
      map-type-id="roadmap"
      class="gmap"
      :options="mapOptions"
      @drag="dragMap"
    >
      <GmapPolyline
        v-if="
          driversData &&
          driversData.drivers &&
          driversData.drivers.length > 0 &&
          driversData.drivers[currentDriverIndex]
        "
        :path="[
          driversData.drivers[currentDriverIndex].position,
          ...driversData.drivers[currentDriverIndex].points,
        ]"
        :strokeWeight="3"
        strokeColor="#E0E0E0"
      />
      <template
        v-if="
          driversData &&
          driversData.drivers &&
          driversData.drivers.length > 0 &&
          driversData.drivers[currentDriverIndex]
        "
      >
        <GmapMarker
          :key="`driver${index}`"
          v-for="(point, index) of driversData.drivers[currentDriverIndex]
            .points"
          :position="point"
          :icon="{
            url: icons.icon_path_point,
            scaledSize: { width: 24, height: 24 },
            anchor: { x: 12, y: 12 },
          }"
          :label="{
            text: (index + 1).toString(),
            fontSize: '12px',
            color: '#32B0F8',
            fontFamily: 'SFPro-Bold, SFPro',
            className: 'path-point',
          }"
        />
      </template>
      <GmapMarker
        v-if="storeData.position"
        :position="storeData.position"
        :clickable="true"
        :icon="{
          url: icons.icon_home,
          scaledSize: { width: 24, height: 24 },
          anchor: { x: 12, y: 12 },
        }"
      />
      <template
        v-if="
          driversData && driversData.drivers && driversData.drivers.length > 0
        "
        v-for="(driver, index) of driversData.drivers"
      >
        <GmapMarker
          v-if="index === currentDriverIndex"
          :key="`driver1${index}`"
          ref="driver-marker"
          :position="driver.position"
          :title="driver.name"
          @click="chooseDriver(index)"
          :icon="{
            url: getIcon(driver.status),
            scaledSize: { width: 16, height: 16 },
            anchor: { x: 8, y: 8 },
          }"
          :z-index="60"
          :label="{
            text: driver.name,
            fontFamily: 'SFPro-Bold, SFPro',
            fontSize: '12px',
            className: 'gmarker-label',
          }"
        />
        <GmapMarker
          v-else
          :key="`driver2${index}`"
          ref="driver-marker"
          :position="driver.position"
          :title="driver.name"
          @click="chooseDriver(index)"
          :icon="{
            url: getIcon(driver.status),
            scaledSize: { width: 16, height: 16 },
            anchor: { x: 8, y: 8 },
          }"
          :z-index="50"
        />
      </template>
      <!-- 目前需求三店不需要右侧 2023 8 21-->
      <template slot="visible" v-if="store != 22">
        <div class="driver-panel">
          <div class="driver-count">
            {{
              driversData.drivers.length === 0
                ? "No"
                : driversData.drivers.length
            }}
            Drivers
          </div>
          <div class="no-driver-tip" v-if="driversData.drivers.length === 0">
            <span>No drivers online currently</span>
          </div>
          <div
            v-if="driversData.drivers.length > 0"
            class="driver-list"
            ref="driver-list"
          >
            <div
              ref="driver"
              v-for="(driver, index) of driversData.drivers"
              @click="chooseDriver(index)"
              class="driver"
              :class="currentDriverIndex === index ? 'selected' : ''"
            >
              <div class="driver-line3">
                <span>{{ driver.bottomText }}</span>
              </div>
              <div class="driver-line1">
                <span
                  v-if="driver.status === 'working'"
                  style="background-color: #32b0f8"
                  class="driver-status"
                ></span>
                <span
                  v-if="driver.status === 'free'"
                  style="background-color: #82d237"
                  class="driver-status"
                ></span>
                <span class="driver-name">{{ driver.name }}</span>
              </div>
              <div class="driver-line2">
                <span>{{ driver.middleText }}</span>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template slot="visible">
        <div class="controls">
          <!--          <div class="control-button logout" @click="logout">-->
          <!--            <svg viewBox="0 0 1024 1024" width="12" height="12">-->
          <!--              <path-->
          <!--                  d="M384 0l0 128 512 0 0 640-512 0 0 128 640 0 0-896-640 0zm-128 256l-256 192 256 192 0-128 512 0 0-128-512 0 0-128z"/>-->
          <!--            </svg>-->
          <!--            <span>Logout</span>-->
          <!--          </div>-->
          <div class="control-button fullscreen" @click="fullScreen">
            <svg
              v-if="!isFullScreen"
              class="icon"
              viewBox="0 0 12 12"
              width="12"
              height="12"
            >
              <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <g
                  transform="translate(-190.000000, -98.000000)"
                  fill="#1F2D42"
                  fill-rule="nonzero"
                >
                  <g transform="translate(184.000000, 92.000000)">
                    <g transform="translate(6.000000, 6.000000)">
                      <path
                        d="M10.8,0 C11.4627491,0 12,0.537256433 12,1.2 L12,1.2 L12,10.8 C12,11.4627508 11.4627508,12 10.8,12 L10.8,12 L1.2,12 C0.537256433,12 0,11.4627491 0,10.8 L0,10.8 L0,1.2 C0,0.53725815 0.53725815,0 1.2,0 L1.2,0 Z M6.6,1.2 L1.2,1.2 L1.2,10.8 L10.8,10.8 L10.8,5.399 L7.2,5.4 C6.90176624,5.4 6.65435325,5.18241039 6.60785299,4.89732312 L6.6,4.8 L6.6,1.2 Z M5.7,5.7 L5.74668425,5.70178934 L5.81929063,5.71185863 L5.88728551,5.72984285 L5.95393293,5.75620402 L6.01242525,5.78759727 L6.07526939,5.83181326 L6.12426407,5.87573593 C6.1455005,5.89697236 6.16481223,5.91940465 6.18219925,5.94281603 L6.2251973,6.00956274 L6.25726471,6.07719839 L6.27849291,6.14040422 L6.29596336,6.23002732 L6.3,6.3 L6.3,8.4 C6.3,8.73137085 6.03137085,9 5.7,9 C5.3922985,9 5.1386957,8.76837589 5.10403664,8.46997268 L5.1,8.4 L5.1,7.7484 L3.12426407,9.72426407 C2.88994949,9.95857864 2.51005051,9.95857864 2.27573593,9.72426407 C2.05944555,9.50797369 2.04280783,9.16763506 2.22582277,8.93226033 L2.27573593,8.87573593 L4.2504,6.9 L3.6,6.9 C3.26862915,6.9 3,6.63137085 3,6.3 C3,5.9922985 3.23162411,5.7386957 3.53002732,5.70403664 L3.6,5.7 L5.7,5.7 Z M10.8,1.2 L7.8,1.2 L7.8,4.2 L10.8,4.2 L10.8,1.2 Z"
                      ></path>
                    </g>
                  </g>
                </g>
              </g>
            </svg>
            <svg v-else viewBox="0 0 12 12" width="12" height="12">
              <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <g
                  transform="translate(-190.000000, -18.000000)"
                  fill="#1F2D42"
                  fill-rule="nonzero"
                >
                  <g transform="translate(184.000000, 12.000000)">
                    <g transform="translate(6.000000, 6.000000)">
                      <path
                        d="M10.8,0 C11.4627491,0 12,0.537256433 12,1.2 L12,1.2 L12,10.8 C12,11.4627508 11.4627508,12 10.8,12 L10.8,12 L1.2,12 C0.537256433,12 0,11.4627491 0,10.8 L0,10.8 L0,1.2 C0,0.53725815 0.53725815,0 1.2,0 L1.2,0 Z M6.6,1.2 L1.2,1.2 L1.2,10.8 L10.8,10.8 L10.8,5.399 L7.2,5.4 C6.90176624,5.4 6.65435325,5.18241039 6.60785299,4.89732312 L6.6,4.8 L6.6,1.2 Z M6.12426407,5.87573593 C6.34055445,6.09202631 6.35719217,6.43236494 6.17417723,6.66773967 L6.12426407,6.72426407 L4.1484,8.7 L4.8,8.7 C5.13137085,8.7 5.4,8.96862915 5.4,9.3 C5.4,9.6077015 5.16837589,9.8613043 4.86997268,9.89596336 L4.8,9.9 L2.66444393,9.89895206 L2.58070937,9.88814137 L2.51271449,9.87015715 L2.44606707,9.84379598 L2.38757475,9.81240273 L2.33226033,9.77417723 L2.27587895,9.72438109 C2.2544995,9.70302764 2.23518777,9.68059535 2.21780075,9.65718397 L2.1748027,9.59043726 L2.14273529,9.52280161 L2.12150709,9.45959578 L2.10403664,9.36997268 L2.1,9.3 L2.1,7.2 C2.1,6.86862915 2.36862915,6.6 2.7,6.6 C3.0077015,6.6 3.2613043,6.83162411 3.29596336,7.13002732 L3.3,7.2 L3.3,7.8504 L5.27573593,5.87573593 C5.51005051,5.64142136 5.88994949,5.64142136 6.12426407,5.87573593 Z M10.8,1.2 L7.8,1.2 L7.8,4.2 L10.8,4.2 L10.8,1.2 Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
            </svg>
          </div>
          <div class="control-button zoom-in" @click="zoomIn">+</div>
          <div class="control-button zoom-out" @click="zoomOut">-</div>
          <div class="control-button reset" @click="toStoreCenter">
            <svg viewBox="0 0 1024 1024" width="12" height="12">
              <path
                d="m945.777778,490.666667l-80.924445,0c-6.698667,-173.752889 -141.127111,-315.264 -311.879111,-332.984889l0,-79.459556a28.444444,28.444444 0 0 0 -56.888889,0l0,78.236445c-178.062222,10.467556 -320.554667,155.207111 -327.452444,334.208l-90.410667,0a28.444444,28.444444 0 0 0 0,56.888889l92.856889,0c20.565333,165.034667 156.928,294.584889 325.006222,304.455111l0,93.767111a28.444444,28.444444 0 0 0 56.888889,0l0,-94.990222c160.881778,-16.696889 289.493334,-143.331556 309.432889,-303.232l83.370667,0a28.444444,28.444444 0 0 0 0,-56.888889zm-392.803556,302.606222l0,-46.606222a28.444444,28.444444 0 0 0 -56.888889,0l0,48.071111c-136.618667,-9.656889 -247.281778,-113.649778 -267.320889,-247.182222l48.568889,0a28.444444,28.444444 0 0 0 0,-56.888889l-51.470222,0c6.826667,-147.555556 123.576889,-266.609778 270.222222,-276.949334l0,63.616a28.444444,28.444444 0 0 0 56.888889,0l0,-62.165333c139.278222,17.379556 248.049778,133.205333 254.648889,275.498667l-60.956444,0a28.444444,28.444444 0 0 0 0,56.888889l58.055111,0c-19.256889,128.412444 -122.339556,229.575111 -251.747556,245.717333z"
              />
            </svg>
          </div>
        </div>
      </template>
    </GmapMap>
  </divs>
</template>

<script>
import mapStyle from "@/api/mapStyle";
import api from "@/api/api";
import icon_home from "@/assets/image/home.svg";
import icon_free from "@/assets/image/circle-free.svg";
import icon_working from "@/assets/image/circle-working.svg";
import icon_path_point from "@/assets/image/path-point.svg";
import { helpers } from "gmap-vue";
import startWs from "@/ws/ws";
import EventBus from "@/ws/eventBus";
import store from "@/store";

import { getDriverMapDefData } from "@/api/driverMap";

const { googleMapsApiInitializer } = helpers;

const initializedZoom = 11;

export default {
  name: "GoogleMap",
  components: {
    // GmapMarker,GmapMap
  },
  data() {
    return {
      timer: "",
      tokenData: null,
      ws: null,
      checkWsInterval: null,
      icons: {
        icon_home,
        icon_free,
        icon_working,
        icon_path_point,
      },
      rollingTimer: null,
      map: null,
      center: {
        lat: 43.6730982190642,
        lng: -79.41431566926937,
      },
      initializedZoom,
      mapOptions: {
        backgroundColor: "#292d31",
        zoomControl: false, //关闭缩放控制
        mapTypeControl: false, //关闭地图类型选择
        scaleControl: true, //
        streetViewControl: false, //关闭街景
        rotateControl: false, //关闭旋转控制
        fullscreenControl: false, //关闭全屏控制
        styles: mapStyle,
        disableDoubleClickZoom: true,
        clickableIcons: false,
      },
      currentDriverIndex: 0,
      driversData: {
        drivers: [],
      },
      storeData: {
        position: { lng: 0, lat: 0 },
        name: "",
      },
      moveDriverInterval: null,
      movingDrivers: [],
      bindTryTimes: 3,
      bound: false,
      isFullScreen: false,
      uid: "",
      timerDown: null,
    };
  },
  methods: {
    getDriversMapDefaultData() {
      if (this.store === "") {
        console.log("--字段this.store没有值---");
      } else {
        getDriverMapDefData({
          uid: this.store,
        })
          .then((res) => {
            if (res.code == 200) {
              console.log("---res.data--", res.data);
              this.handleDriverMessage(res.data);
            } else {
              this.$message({
                message: res.message,
                type: "warning",
              });
            }
            if (res.code == 400) {
              this.$message({
                message: res.msg,
                type: "warning",
              });
            }
          })
          .catch((err) => {
            this.$message({
              message: err.message,
              type: "error",
            });
          });
      }
    },

    //点击司机坐标点或者点击右侧item
    chooseDriver(index, isAuto = false) {
      // console.log("---dianjile---", index);

      this.startRollingTimer();
      //当前司机
      this.currentDriverIndex = index;
      if (isAuto && this.driversData.drivers.length > 0) {
        this.$refs["driver-list"].scrollTo({
          top: this.$refs["driver"][index].offsetTop,
          behavior: "smooth",
        });
        this.storeToCenter(); //设置地图中心点为店铺
        let driver = this.driversData.drivers[index];
        // this.panToDriverPositon(driver.position)//设置地图中心点为司机
        // console.log('--aaaaa---',driver)

        // let backTime = driver.backTime;
        // if ((typeof backTime === 'number') && backTime > 0 && backTime < 1200) {
        //   //播报
        //   let speechSynthesis = window.speechSynthesis;
        //   let minutes = Math.ceil(backTime / 60);
        //   let text;
        //   if (minutes > 1){
        //     text = driver.name + ' will be back in ' + numberToWords.toWords(minutes) + ' minutes.';
        //   }else {
        //     text = driver.name + ' will be back in ' + numberToWords.toWords(minutes) + ' minute.';
        //   }
        //   let speechSynthesisUtterance = new SpeechSynthesisUtterance(text);
        //   speechSynthesis.speak(speechSynthesisUtterance);
        // }
        let broadcastAudio = driver.broadcastAudio;
        if (broadcastAudio) {
          let audio = new Audio(broadcastAudio);
          audio.play();
        }
      }
    },
    getIcon(status) {
      switch (status) {
        case "free":
          return this.icons.icon_free;
        case "working":
          return this.icons.icon_working;
        default:
          return this.icons.icon_home;
      }
    },
    dragMap() {
      this.startRollingTimer();
    },
    toStoreCenter() {
      this.map.setZoom(initializedZoom);
      this.storeToCenter();
    },
    zoomIn() {
      this.map.setZoom(this.map.getZoom() + 1);
    },
    zoomOut() {
      this.map.setZoom(this.map.getZoom() - 1);
    },
    logout() {
      this.$router.push("/login");
    },
    startRollingTimer() {
      if (this.store != 22) {
        // console.log("--自动定时器移动下一个---");
        if (this.rollingTimer !== null) {
          try {
            window.clearTimeout(this.rollingTimer);
          } catch (e) {
            /**/
          }
        }
        this.rollingTimer = setTimeout(() => {
          let nextIndex;
          if (this.currentDriverIndex < this.driversData.drivers.length - 1) {
            nextIndex = this.currentDriverIndex + 1;
          } else {
            nextIndex = 0;
          }
          this.chooseDriver(nextIndex, true);
        }, 30000);
      }
    },
    setPosition() {
      // let lng = this.$refs['debugger-lng'].value;
      // let lat = this.$refs['debugger-lat'].value;
      // lng = parseFloat(lng);
      // lat = parseFloat(lat);
      // let position = {
      //   lng,
      //   lat
      // };
      // this.driverAnimateMove(this.currentDriverIndex, position)
    },
    storeToCenter() {
      // console.log(
      //   "--设置地图中心为当前店铺--",
      //   this.storeData.position,
      //   this.map
      // );
      if (this.map) {
        this.map.panTo(this.storeData.position);
        this.map.panBy(112, 0);
      }
    },
    panToDriverPositon(position) {
      if (this.map) {
        this.map.panTo(position);
        this.map.panBy(112, 0);
      }
    },

    decodeToken() {
      // console.log("--地图相关初始化---");
      this.$refs["gmap"].$mapPromise.then((map) => {
        this.map = map;
      });
      // let query = this.$route.query;
      // let token = query.token;
      //如果是admin token 需要再vuex里面取  如果不是 就在session里面取
      let tokens = "";
      tokens = localStorage.getItem("token");
      let tokenInQuery = !!tokens;
      if (!tokenInQuery) {
        tokens = localStorage.getItem("token");
      }
      if (!tokens) {
        alert("Wrong Parameter!");
        this.logout();
        return;
      }
      tokens = tokens.toString();
      let strings = tokens.split(".");
      let tokenInfo = JSON.parse(
        decodeURIComponent(
          escape(window.atob(strings[1].replace(/-/g, "+").replace(/_/g, "/")))
        )
      );
      if (!tokenInfo) {
        alert("Wrong Parameter!");
        this.logout();
        return;
      }
      if (!tokenInfo.data) {
        alert("Wrong Parameter!");
        this.logout();
        return;
      }

      // console.log("--this.map--", this.map);

      this.startRollingTimer();
      this.storeToCenter();
      this.sendBindMessage();

      //此处会直接返回 2023年7月20日
      if (!tokenInfo.data["LOCATION"]) {
        return;
      }

      let locationArr = tokenInfo.data["LOCATION"].split(",");
      let lngLat = this.parseArray2lngLat(locationArr);
      this.storeData.position = lngLat;
      api.getGoogleMapsApiKey(tokens).then((res) => {
        let key = res.data;
        googleMapsApiInitializer(
          {
            key: key,
            libraries: "places",
            v: "3.49",
          },
          false
        );
      });

      let username = tokenInfo.data["USERNAME"];
      if (!username) {
        username = "";
      }
      this.storeData.name = username;
      this.tokenData = tokens;
      localStorage.setItem("driver_map_token", tokens);

      // 将以下方法全部上移 2023年7月20日
      // this.storeToCenter();
      // this.startRollingTimer();
      // this.sendBindMessage();
    },

    // {
    //   "type": "driverMapHeart",
    //   "uid": 2
    // }
    /**
     * 设置一个定时器 向后端发送心跳
     * @param {*} isDefault
     */
    sendHeart(isDefault) {
      if (this.store === "") {
        // console.log('--字段this.store没有值--发送心跳--')
      } else {
        // console.log("--发送心跳--", this.store);
        startWs.ws.send(
          JSON.stringify({
            type: "driverMapHeart",
            uid: this.store,
          })
        );
        if (isDefault) {
          this.timer = setInterval(() => {
            startWs.ws.send(
              JSON.stringify({
                type: "driverMapHeart",
                uid: this.store,
              })
            );
            // console.log("--定时发送心跳执行--", this.store);
          }, 60000);
        }
      }
    },
    sendBindMessage() {
      if (startWs.ws) {
        // if (startWs.ws.readyState == 1){
        //   startWs.ws.send(JSON.stringify({
        //     type: 'bindWorker'//   "uid": 2
        //     token: localStorage.getItem('token')
        //   }));
        // }
      } else {
        alert("Wrong Parameter!");
        this.logout();
        return;
      }
    },
    //连接成功后 拿到位置跟店铺名字
    handleOnBindMessage(message) {
      if (!message) {
        return;
      }
      this.bound = true; //ws.bound
      let hubPoint = message.hub_point;
      if (!hubPoint) {
        return;
      }
      let arr = hubPoint.split(",");
      this.storeData.name = message.uid;
    },
    handleDriverMessage(message) {
      // console.log("--处理信息数据--", message);

      if (!message) {
        return;
      }
      let lng = message.hub_position.longitude;
      let lat = message.hub_position.latitude;
      this.storeData.position = {
        lng: lng instanceof Number ? lng : parseFloat(lng.toString().trim()),
        lat: lat instanceof Number ? lat : parseFloat(lat.toString().trim()),
      };
      // console.log("--this.storeData.position--", this.storeData.position);
      let workers = message.data;
      if (!workers) {
        return;
      }

      let findById = (id) => {
        for (let driver of this.driversData.drivers) {
          if (driver.id === id) {
            return driver;
          }
        }
        return null;
      };
      let drivers = [];
      let moveDriverIndexes = [];

      for (let i = 0; i < workers.length; i++) {
        let worker = workers[i];
        let driver = findById(worker.worker_id);
        let points = [];
        for (let p of worker.point) {
          points.push(this.parseObjectlngLat(p));
        }
        drivers.push({
          id: worker.worker_id,
          status: worker.point.length === 0 ? "free" : "working",
          name: worker.name,
          middleText: worker.task_count_desc,
          bottomText: worker.back_time_desc,
          backTime: worker.back_time,
          position: driver
            ? driver.position
            : this.parseObjectlngLat(worker.current_point),
          points: points,
          broadcastAudio: worker.broadcast_url,
        });
      }
      this.driversData.drivers = drivers;
      // console.log(
      //   this.driversData.drivers,
      //   "this.driversData.drivers",
      //   this.checkWindowVisible()
      // );

      //设置倒计时
      this.countDown();

      for (let i = 0; i < workers.length; i++) {
        let worker = workers[i];
        let driver = findById(worker.worker_id);
        if (driver) {
          moveDriverIndexes.push({
            index: i,
            target: this.parseObjectlngLat(worker.current_point),
          });
        }
      }

      if (this.checkWindowVisible()) {
        for (let moveDriverIndex of moveDriverIndexes) {
          //可见状态动画移动
          this.driverAnimateMove(
            moveDriverIndex.index,
            moveDriverIndex.target,
            450
          );
        }
      } else {
        for (let moveDriverIndex of moveDriverIndexes) {
          //不可见状态直接变过去
          this.driversData.drivers[moveDriverIndex.index].position =
            moveDriverIndex.target;
        }
      }

      this.storeToCenter();
    },
    //倒计时处理
    countDown() {
      clearInterval(this.timerDown); // 倒计时结束，停止计时器

      // console.log("------asdf----------");
      let datas = this.driversData.drivers;
      // console.log("---倒计时数据--", datas);
      //1.找出数组中最大的数
      let maxTime = this.findMaxNum(datas);
      // console.log("--最大的时间是--", maxTime);
      let countNum = 0;
      // 启动计时器，每秒更新count值
      this.timerDown = setInterval(() => {
        if (maxTime > 0) {
          // console.log("---正在倒计时--", maxTime);
          this.setDataCountDown(datas, countNum);
          maxTime -= 60;
          countNum++;
        } else {
          clearInterval(this.timerDown); // 倒计时结束，停止计时器
        }
      }, 1000 * 60);
    },
    findMaxNum(data) {
      let max = 0;
      for (let i = 0; i < data.length; i++) {
        const e = data[i].backTime;
        if (e > max) {
          max = e;
        }
      }
      return max;
    },
    setDataCountDown(data, countNum) {
      for (let i = 0; i < data.length; i++) {
        const item = data[i];
        if (item.backTime > 0) {
          let min = item.backTime / 60 - countNum;
          min = parseInt(min);
          if (min > 60) {
            item.bottomText = `Back in ${this.minTimeFomat(min)}`;
          } else if (min <= 0) {
            item.bottomText = `At hub`; //At hub  Back in 0 mins
          } else {
            item.bottomText = `Back in ${min} mins`;
          }
        }
      }
      console.log("---改变后的data--", data);
    },

    minTimeFomat(min) {
      let minTime = "";
      let h = Math.floor(min / 60);
      min -= h * 60;
      if (min == 0) {
        minTime = h ? "" + h + ":00" : "";
      } else {
        if (min < 10) {
          min = "" + min;
        }
        if (h < 10) {
          h = "" + h;
        }
        minTime = (h ? " " + h + " h" : "") + (min ? " " + min + " mins" : "");
      }
      return minTime;
    },

    parseObjectlngLat(obj) {
      if (!obj || obj.length < 2) {
        return {
          lng: 0,
          lat: 0,
        };
      }
      let lng = obj.longitude;
      let lat = obj.latitude;

      if (!lng || !lat) {
        return {
          lng: 0,
          lat: 0,
        };
      }
      lng = lng instanceof Number ? lng : parseFloat(lng.toString().trim());
      lat = lat instanceof Number ? lat : parseFloat(lat.toString().trim());
      if (!lng) {
        lng = 0;
      }
      if (!lat) {
        lat = 0;
      }
      return {
        lng: lng,
        lat: lat,
      };
    },

    parseArray2lngLat(arr) {
      if (!arr || arr.length < 2) {
        return {
          lng: 0,
          lat: 0,
        };
      }
      let lng = arr[0];
      let lat = arr[1];
      if (!lng || !lat) {
        return {
          lng: 0,
          lat: 0,
        };
      }
      lng = lng instanceof Number ? lng : parseFloat(lng.toString().trim());
      lat = lat instanceof Number ? lat : parseFloat(lat.toString().trim());
      if (!lng) {
        lng = 0;
      }
      if (!lat) {
        lat = 0;
      }
      return {
        lng: lng,
        lat: lat,
      };
    },
    driverAnimateMove(index, target, duration = 450) {
      // console.log("--axiab--", index, target);
      let interval = 30;
      let position = this.driversData.drivers[index].position;
      let lngDiff = target.lng - position.lng;
      let latDiff = target.lat - position.lat;
      let stepCount;
      if (stepCount % interval === 0) {
        stepCount = duration / interval;
      } else {
        stepCount = Math.floor(duration / interval) + 1;
      }
      let lngStep = lngDiff / stepCount;
      let latStep = latDiff / stepCount;

      this.movingDrivers.push({
        driverIndex: index,
        lngStep,
        latStep,
        stepCount,
        currentStep: 0,
        target,
      });

      // console.log("---movingDrivers---", this.movingDrivers);
    },

    checkWindowVisible() {
      return document.visibilityState === "visible";
    },
    startMoveDriverInterval() {
      // console.log("---startMoveDriverInterval---", this.movingDrivers);

      this.moveDriverInterval = setInterval(() => {
        let finishedMovingDriverIndexes = [];
        for (let i = 0; i < this.movingDrivers.length; i++) {
          let movingDriver = this.movingDrivers[i];
          if (movingDriver.currentStep >= movingDriver.stepCount) {
            this.driversData.drivers[movingDriver.driverIndex].position =
              movingDriver.target;
            finishedMovingDriverIndexes.push(i);
            break;
          }
          this.driversData.drivers[movingDriver.driverIndex].position = {
            lng:
              this.driversData.drivers[movingDriver.driverIndex].position.lng +
              movingDriver.lngStep,
            lat:
              this.driversData.drivers[movingDriver.driverIndex].position.lat +
              movingDriver.latStep,
          };
          movingDriver.currentStep++;
        }
        for (let finishedMovingDriverIndex of finishedMovingDriverIndexes) {
          this.movingDrivers.splice(finishedMovingDriverIndex, 1);
        }

        // console.log('----定时移动？？？---',this.movingDrivers)
      }, 30);
    },
    //全屏？
    fullScreen() {
      let div = this.map.getDiv().firstChild;
      this.isFullScreen = !this.isFullScreen;
      if (this.isFullScreen) {
        if (document.body.requestFullscreen) {
          document.body.requestFullscreen();
        } else if (div.webkitRequestFullScreen) {
          document.body.webkitRequestFullScreen();
        } else if (div.mozRequestFullScreen) {
          document.body.mozRequestFullScreen();
        } else if (div.msRequestFullScreen) {
          document.body.msRequestFullScreen();
        }
      } else {
        document.exitFullscreen();
      }
    },
  },
  created() {
    EventBus.$on("driverMapChangeDriver", (a) => {
      this.driversData.drivers.forEach((driver, index) => {
        if (driver.id == a.worker_id) {
          driver.position.lat = Number(a.latitude);
          driver.position.lng = Number(a.longitude);
        }
      });
    });
    EventBus.$on("updateDriverMapStatus", (message) => {
      // console.log(message, "看看司机上下限", this.driversData.drivers);
      if (message.is_online == 1) {
        //司机上线
        let driver = this.driversData.drivers.findIndex(
          (v) => v.id == message.worker_id
        );
        if (driver == -1) {
          let arr = this.driversData.drivers;
          arr.push({
            backTime: 0,
            bottomText: "At hub",
            broadcastAudio: "",
            id: message.worker_id,
            middleText: "No Tasks",
            name: message.name,
            points: [],
            position: {
              lat: Number(message.latitude),
              lng: Number(message.longitude),
            },
            status: "free",
          });
          this.driversData.drivers = arr;
        }
        // console.log(this.driversData.drivers, "司机上线");
      } else {
        this.driversData.drivers.forEach((driver, index) => {
          //司机下线
          if (driver.id == message.worker_id) {
            this.driversData.drivers.splice(index, 1);
            // console.log(this.driversData.drivers, "司机下线");
          }
        });
      }

      this.$forceUpdate();
    });
    EventBus.$on("onBindDriverMap", (msg) => {
      // console.log("--接收WS发送的消息--", msg);
      if (msg.type == "workerMapData") {
        this.handleDriverMessage(msg);
      }
    });
  },
  mounted() {
    // console.log("---driverMap.vue--mounted-----");

    this.getDriversMapDefaultData();

    this.sendHeart(true);
    this.decodeToken();
    // this.startMoveDriverInterval();
    window.onresize = () => {
      this.isFullScreen = !!document.fullscreenElement;
    };

    // [X] 在此处没有效果 2023年7月25日
    // EventBus.$on("onBindDriverMap", (message) => {
    //   console.log('--接搜WS--onBindDriverMap--事件消息--',message)
    //   if (message.type == "onBindWorker") {
    //     this.handleOnBindMessage(message);
    //   }
    //   if (message.type == "workerMapData") {
    //     console.log("--接收WS发送的消息--", message);
    //     this.handleDriverMessage(message);
    //   }
    // });
  },
  destroyed() {
    // console.log(this.moveDriverInterval, "moveDriverInterval");
    if (this.rollingTimer !== null) {
      try {
        window.clearTimeout(this.rollingTimer);
      } catch (e) {
        //
      }
    }
    if (this.checkWsInterval !== null) {
      try {
        window.clearInterval(this.checkWsInterval);
      } catch (e) {
        //
      }
    }
    if (this.moveDriverInterval !== null) {
      try {
        window.clearInterval(this.moveDriverInterval);
      } catch (e) {
        //
      }
    }
    // console.log(this.moveDriverInterval, "moveDriverInterval");
  },
  //监听 vuex 的token 如果token变化 赋值给 session 调用 decodeToken
  computed: {
    store() {
      // console.log(store.state.store, "改变了店铺id");
      return store.state.store;
    },
  },
  beforeDestroy() {
    // console.log(this.timer);
    window.clearInterval(this.timer);
    this.timer = null;
    EventBus.$off("onBindDriverMap");
    EventBus.$off("updateDriverMapStatus");
    EventBus.$off("driverMapChangeDriver");
    // console.log("--driverMap.vue--beforeDestory-----");
    // 组件销毁时清除计时器
    window.clearInterval(this.timerDown);
    this.timerDown = null;
  },

  watch: {
    store: {
      deep: true,
      handler: function (n, o) {
        // console.log("--门店发生改变0111---", n);
        if (n != "") {
          this.getDriversMapDefaultData();
          this.sendHeart(false);
        }
      },
    },
  },
};
</script>

<style scoped>
.gmap {
  width: 100%;
  height: 100%;
}

.driver-panel {
  top: 16px;
  right: 16px;
  bottom: 16px;
  /* width: 225px; */
  width: 320px;
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.9);
  position: absolute;
  z-index: 100;
  overflow: auto;
}

.driver-count {
  font-family: SFPro-Bold, SFPro, sans-serif;
  font-weight: bold;
  margin: 16px;
  text-align: left;
}

.driver-list {
  position: absolute;
  top: 50px;
  left: 0;
  bottom: 16px;
  right: 0;
  /*overflow-y: scroll;*/
}

.driver {
  /* width: 193px; */
  width: 288px;
  height: 120px;
  border-radius: 16px;
  margin-left: 16px;
  margin-bottom: 8px;
  cursor: pointer;
  font-family: SFPro-Bold, SFPro, sans-serif;
  font-size: 12px;
  box-sizing: border-box;
  border: 1px solid transparent;
  transition: 300ms;
}

.driver:hover {
  background-color: #f5f6fb;
  border: 1px solid #d0d0d0;
}

.driver.selected {
  background-color: #ffffff;
  border: 1px solid #e0e0e0;
}

.driver-line1 {
  width: 170px;
  font-size: 12px;
  margin-left: 18px;
  line-height: 18px;
  margin-top: 8px;
  font-weight: bold;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: left !important;
}

.driver-status {
  display: inline-block;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  vertical-align: middle;
  box-sizing: border-box;
  border: 1px solid #ffffff;
}

.driver-name {
  vertical-align: middle;
  display: inline-block;
  margin-left: 8px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  width: 146px;
  font-weight: bold;
  font-size: 14px;
}

.driver-line2 {
  margin-left: 16px;
  margin-top: 8px;
  width: 170px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: left;
}

.driver-line2 span {
  margin-left: 24px;
}

.driver-line3 {
  margin-left: 16px;
  margin-top: 16px;
  line-height: 30px;
  font-size: 20px;
  color: #000000;
  font-weight: bold;
  /* width: 170px; */
  max-width: 250px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: left;
}

.driver-line3 span {
  /*margin-left: 24px;*/
}

/deep/ .gmarker-label {
  background-color: #ffffff;
  position: absolute;
  display: inline-block;
  height: 24px;
  line-height: 24px;
  padding: 0 6px;
  box-sizing: border-box;
  border-radius: 4px;
  text-align: left;
  transform: translate(24px, -12px);
  z-index: 0;
}

/deep/ .path-point {
  margin-bottom: 1px;
}

.no-driver-tip {
  position: absolute;
  top: 50px;
  left: 0;
  bottom: 16px;
  right: 0;
  overflow-y: auto;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-family: SFPro-Regular, SFPro, sans-serif;
  font-weight: 400;
  color: #999999;
}

.controls {
  position: absolute;
  left: 12px;
  top: 12px;
}

.controls .control-button {
  width: 24px;
  height: 24px;
  box-sizing: border-box;
  background-color: #ffffff;
  text-align: center;
  line-height: 24px;
  user-select: none;
  cursor: pointer;
  position: relative;
}

.controls .control-button.fullscreen {
  /*margin-top: 8px;*/
  text-align: left;
  border-radius: 4px;
  box-sizing: border-box;
  padding-left: 6px;
}

.controls .control-button.fullscreen:hover:after {
  content: "Full Screen";
  position: absolute;
  background-color: #ffffff;
  left: 32px;
  top: 0;
  display: block;
  width: 90px;
  font-size: 12px;
  border-radius: 4px;
  text-align: center;
}

.controls .zoom-in {
  margin-top: 8px;
  border-radius: 4px 4px 0 0;
}

.controls .zoom-in:hover:after {
  content: "Zoom in";
  position: absolute;
  background-color: #ffffff;
  left: 32px;
  top: 0;
  display: block;
  width: 60px;
  font-size: 12px;
  border-radius: 4px;
}

.controls .zoom-out {
  border-radius: 0 0 4px 4px;
}

.controls .zoom-out:hover:after {
  content: "Zoom out";
  position: absolute;
  background-color: #ffffff;
  left: 32px;
  top: 0;
  display: block;
  width: 72px;
  font-size: 12px;
  border-radius: 4px;
}

.controls .reset {
  margin-top: 8px;
  border-radius: 4px;
}

.controls .reset:hover:after {
  content: "Back to store";
  position: absolute;
  background-color: #ffffff;
  left: 32px;
  top: 0;
  display: block;
  width: 84px;
  font-size: 12px;
  border-radius: 4px;
}

.controls .control-button:hover {
  background-color: rgba(255, 255, 255, 0.9);
}

.controls .control-button:active {
  background-color: rgba(255, 255, 255, 0.95);
}

.controls .control-button.logout {
  text-align: left;
  width: 72px;
  border-radius: 4px;
  box-sizing: border-box;
  padding-left: 6px;
}

.controls .control-button.logout span {
  font-size: 12px;
  display: inline-block;
  vertical-align: top;
  margin-left: 6px;
  font-family: SFPro-Regular, SFPro, sans-serif;
}

.debugger {
  position: absolute;
  left: 10px;
  bottom: 10px;
  width: 200px;
  height: 100px;
  background-color: #ffffff;
  box-sizing: border-box;
  padding: 10px;
}
</style>
